import { FormikProps, useFormik } from 'formik';
import { IVerifyAudition } from 'shared/interfaces/IAudition';
import * as yup from 'yup';

type FormProps = {
  onSubmit: (values: IVerifyAudition) => void;
};
export const useVerificationForm = ({ onSubmit }: FormProps) => {
  const initialValues: IVerifyAudition = {
    first_name: '',
    last_name: '',
    casting_role_id: '',
    agency_id: '',
  };

  const validationscheme = yup.object({
    first_name: yup.string().required('First name is required'),
    last_name: yup.string().required('Last name is required'),
    casting_role_id: yup.string().required('Casting role is required'),
  });

  const form: FormikProps<IVerifyAudition> = useFormik({
    initialValues,
    validationSchema: validationscheme,
    // validateOnBlur: true,
    onSubmit: (values) => onSubmit(values),
  });

  return {
    form,
  };
};
